import { HTMLAttributes, ReactNode } from 'react';

/**
 * SystemEvent — centered quiet pill for non-message chat events.
 */
export interface SystemEventProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export function SystemEvent({ children, style, ...props }: SystemEventProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} {...props}>
      <span
        style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-meta)',
          color: 'var(--text-dim)',
          background: 'var(--surface)',
          border: '1px solid var(--line)',
          borderRadius: 'var(--r-pill)',
          padding: '4px 14px',
          ...style,
        }}
      >
        {children}
      </span>
    </div>
  );
}

export default SystemEvent;
